// https://github.com/aws-amplify/amplify-cli/issues/2420

export const getInventorie = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
      owner
      groups
      active
      status
      lotNumber
      poNumber
      railCarNumber
      containerNumber
      receivedAt
      depletedAt
      turnDays
      lastOutboundId
      quantityAdvised
      quantityReceived
      quantityPrecount
      quantityOnHand
      quantityPhysical
      quantityCommitted
      quantityMismatch
      inventoryUOM
      weight
      weightUOM
      pcs
      pcsHeight
      pcsWidth
      pcsLength
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        id
        name
        prefix
        areaType
        sortKey
        zones {
          items {
            id
            accountId
            areaId
            name
            prefix
          }
        }
      }
      zoneId
      aisleList
      photos {
        items {
          id
          key
          name
        }
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      productName
      productCode
      productId
      braRawProductName
      product {
        id
        # owner
        altNames
        groups
        active
        accountId
        reloadYardId
        name
        productCode
        reloadYardCommodityId
        category
        defaultUOM
        defaultWeightUOM
        unit
        pcs
        mbf
        lf
        sf
        msf
        sqm
        gal
        l
        lbs
        tn
        cwt
        kg
        mt
        ft
        m
        # height
        # width
        # length
        lowInventoryThreshold
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryAlert
        customFields
      }
      sortKey
      accountName
      accountId
      account {
        id
        groups
        active
        # status
        # externalId
        # lotNumberPrefix
        businessName
        displayName
        accountType
        defaultBillToAccountId
        requireDefaultZone
        defaultWeightUOM
        reloadYardId
        inventoryCustomFields {
          id
          name
          type
          display
          required
        }
      }
      reloadYardId
      inboundShipmentId
      inboundShipment {
        id
        # owner
        groups
        active
        status
        state
        poNumber
        lotNumber
        lotNumberOverride
        shipFrom
        carrierType
        # carrierName
        lotType
        railCarNumber
        containerDrop
        totalUOM
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        history {
          type
          date
          by
          text
        }
        accountName
        accountId
        reloadYardId
        invoiceId
        areaId
        isCollected
        sit
        reloadYardCommodityId
        customFields
        selectedCustomFields {
          id
          name
          type
          display
        }
      }
      shipmentLineItems {
        items {
          id
          # owner
          # groups
          active
          status
          sortKey
          lotNumber
          totalQuantityToPick
          poNumber
          outboundShipmentId
          # accountId
          # reloadYardId
          inventoryId
          inventoryItems {
            items {
              id
              inventoryItemId
              quantityToPick
              updatedAt
            }
          }
          updatedAt
        }
        # nextToken
      }
      auditId
      reloadYardCommodityId
      reloadYardCommodity {
        id
        # reloadYardId
        commodityId
        # owner
        # groups
        # active
        # verified
        units
        sortKey
        commodity {
          id
          # active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
          inventoryFields
        }
      }
      inventoryItems {
        items {
          id
          quantityOnHand
          quantityCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          depletedAt
          status
          areaId
          zoneId
          aisleId
          locationId
          location {
            id
            active
            name
            type
            areaId
            area {
              name
              prefix
              areaType
            }
            zoneId
            zone {
              name
              prefix
              accountId
            }
            aisleId
            aisle {
              id
              active
              name
              type
              bays
              levels
              capacityUsed
              sortKey
            }
            bay
            level
            position
            capacityAllocated
            capacityUsed
            sortKey
            productId
            locationLoad {
              other {
                selected
                capacity
              }
              pallet {
                selected
                capacity
              }
              box {
                selected
                capacity
              }
              container {
                selected
                capacity
              }
              superSack {
                selected
                capacity
              }
              dryBulk {
                selected
                capacity
              }
              liquidBulk {
                selected
                capacity
              }
            }
          }
          history {
            type
            date
            by
            text
          }
          outboundShipmentId
          locationFullName
          latitude
          longitude
          unloadedBy
          unloadedAt
          updatedAt
        }
      }
      customFields
      # createdAt
      updatedAt
    }
  }
`;

export const getInventorieValidate = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
      inventoryItems {
        items {
          id
          updatedAt
        }
      }
      updatedAt
    }
  }
`;

// Fresh read for the released-railcar pick guard (utils/releasedRailcar.js):
// whether the inventory's railcar has left, straight from the inbound rather
// than from the pick list loaded when the form opened.
export const getInventorieReleaseState = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
      areaId
      railCarNumber
      productName
      lotNumber
      inboundShipment {
        id
        status
        carrierType
        collectedDateTime
        isCollected
        railCarNumber
      }
    }
  }
`;

export const locationByAreaBySortKey = /* GraphQL */ `
  query LocationByAreaBySortKey(
    $reloadYardId: ID
    $areaIdSortKey: ModelLocationLocationByAreaBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByAreaBySortKey(
      reloadYardId: $reloadYardId
      areaIdSortKey: $areaIdSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountName
        name
        reloadYardId
        type
        areaId
        area {
          name
          prefix
          color
          areaType
        }
        zoneId
        zone {
          name
          prefix
          color
          reloadYardCommodityId
        }
        aisleId
        aisle {
          id
          name
          type
          areaId
          levels
          positions
          capacityUsed
          sortKey
          area {
            name
            prefix
          }
          zone {
            name
            prefix
          }
        }
        bay
        position
        capacityAllocated
        capacityUsed
        sortKey
        productId
        productName
        bulkCapacity
        bulkUnits
      }
      nextToken
    }
  }
`;

export const inventoryItemByAisleByStatus = /* GraphQL */ `
  query InventoryItemByAisleByStatus(
    $aisleId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAisleByStatus(
      aisleId: $aisleId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        quantityCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        unloadedBy
        unloadedAt
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          railCarNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          productName
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          auditId
          reloadYardCommodityId
          customFields
        }
        areaId
        zoneId
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityUsed
          capacityAllocated
          sortKey
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
      }
      nextToken
    }
  }
`;

export const inventoryItemByAisleByStatusLookup = /* GraphQL */ `
  query InventoryItemByAisleByStatus(
    $aisleId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAisleByStatus(
      aisleId: $aisleId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        quantityOnHand
        unloadedBy
        unloadedAt
        inventory {
          inventoryUOM
          reloadYardCommodity {
            commodity {
              id
              name
              description
              locationLoadType
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const inventoryItemByAisleByStatusForUpdate = /* GraphQL */ `
  query InventoryItemByAisleByStatus(
    $aisleId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAisleByStatus(
      aisleId: $aisleId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quantityOnHand
        unloadedBy
        unloadedAt
        inventoryId
        aisleId
        zoneId
        areaId
        locationId
        location {
          id
          aisleId
          areaId
          zoneId
          sortKey
          active
          capacityUsed
          capacityAllocated
          bay
        }
      }
      nextToken
    }
  }
`;

export const inventoryItemByLocationByStatus = /* GraphQL */ `
  query InventoryItemByLocationByStatus(
    $locationId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByLocationByStatus(
      locationId: $locationId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        quantityCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        inboundShipmentId
        inventoryId
        unloadedBy
        unloadedAt
        history {
          type
          date
          by
          text
        }
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          receivedAt
          depletedAt
          lastOutboundId
          turnDays
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          weight
          weightUOM
          verificationRequired
          lotType
          areaId
          zoneId
          productName
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          auditId
          reloadYardCommodityId
          reloadYardCommodity {
            commodity {
              id
              name
              description
              locationLoadType
            }
          }
          customFields
        }
        areaId
        zoneId
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          area {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            color
            areaType
            sortKey
          }
          zoneId
          zone {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            accountId
            areaId
            color
            zoneType
            sortKey
          }
          aisleId
          aisle {
            id
            owner
            groups
            active
            reloadYardId
            name
            type
            areaId
            zoneId
            bays
            levels
            capacityUsed
            topDownPickOrder
            sortKey
          }
          bay
          level
          position
          capacityUsed
          capacityAllocated
          length
          width
          sortKey
          locationLoad {
            other {
              selected
              capacity
            }
            pallet {
              selected
              capacity
            }
            box {
              selected
              capacity
            }
            container {
              selected
              capacity
            }
            superSack {
              selected
              capacity
            }
            dryBulk {
              selected
              capacity
            }
            liquidBulk {
              selected
              capacity
            }
          }
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        updatedAt
      }
      nextToken
    }
  }
`;

export const inventoryByAreaByProductByStatus = /* GraphQL */ `
  query InventoryByAreaByProductByStatus(
    $areaId: ID
    $productIdStatus: ModelInventoryInventoryByAreaByProductByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByAreaByProductByStatus(
      areaId: $areaId
      productIdStatus: $productIdStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        lotNumber
        poNumber
        railCarNumber
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityCommitted
        inventoryUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        containerNumber
        otherException
        otherExceptionNote
        lotType
        areaId
        zoneId
        aisleList
        aggregateInventoryId
        history {
          type
          date
          by
          text
        }
        accountId
        accountName
        productId
        productName
        inboundShipmentId
        inventoryItems {
          items {
            id
            areaId
            zoneId
            aisleId
            locationId
            inventoryId
            inboundShipmentId
            locationFullName
            reloadYardId
            status
            quantityOnHand
            quantityCommitted
            outboundShipmentId
            hasException
            isDamaged
            otherException
            otherExceptionNote
          }
        }
      }
    }
  }
`;

export const inventoryByAreaByProductByStatusMax = /* GraphQL */ `
  query InventoryByAreaByProductByStatus(
    $areaId: ID
    $productIdStatus: ModelInventoryInventoryByAreaByProductByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByAreaByProductByStatus(
      areaId: $areaId
      productIdStatus: $productIdStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        lotNumber
        poNumber
        railCarNumber
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityCommitted
        inventoryUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        otherException
        otherExceptionNote
        lotType
        areaId
        zoneId
        aisleList
        aggregateInventoryId
        history {
          type
          date
          by
          text
        }
        accountId
        accountName
        productId
        productName
        inboundShipmentId
        inboundShipment {
          id
          groups
          active
          status
          state
          poNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          carrierName
          lotType
          railCarNumber
          totalUOM
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          accountName
          accountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          customFields
        }
        inventoryItems {
          items {
            id
            areaId
            zoneId
            aisleId
            locationId
            inventoryId
            inboundShipmentId
            locationFullName
            reloadYardId
            status
            quantityOnHand
            quantityCommitted
            outboundShipmentId
            hasException
            isDamaged
            otherException
            otherExceptionNote
          }
        }
      }
    }
  }
`;

export const inventoryItemByLocationByStatusInbound = /* GraphQL */ `
  query InventoryItemByLocationByStatus(
    $locationId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByLocationByStatus(
      locationId: $locationId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quantityOnHand
        quantityCommitted
        unloadedAt
        inventoryId
        status
        inventory {
          productName
          productCode
          accountName
          reloadYardCommodity {
            commodity {
              name
              locationLoadType
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const inventoryItemByLocationByStatusLookup = /* GraphQL */ `
  query InventoryItemByLocationByStatus(
    $locationId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByLocationByStatus(
      locationId: $locationId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        areaId
        zoneId
        aisleId
        locationId
        inventoryId
        inboundShipmentId
        accountId
        reloadYardId
        quantityOnHand
        quantityCommitted
        locationFullName
        unloadedBy
        unloadedAt
      }
      nextToken
    }
  }
`;

export const inventoryItemByInventoryByStatusMini = /* GraphQL */ `
  query InventoryItemByInventoryByStatus(
    $inventoryId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByInventoryByStatus(
      inventoryId: $inventoryId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quantityOnHand
        quantityCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        unloadedBy
        unloadedAt
        inventoryId
        inventory {
          id
          inventoryUOM
          sortKey
        }
        location {
          id
          active
          name
          type
          areaId
          area {
            id
            active
            name
            prefix
            areaType
            sortKey
          }
          zoneId
          zone {
            id
            active
            name
            prefix
            accountId
            zoneType
            sortKey
          }
          aisleId
          aisle {
            id
            active
            name
            type
            topDownPickOrder
            sortKey
          }
          bay
          level
          position
          sortKey
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
      }
      nextToken
    }
  }
`;

export const getInventorieAiles = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      inventoryItems {
        items {
          aisleId
        }
      }
    }
  }
`;

export const getInventorieInbound = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
      groups
      reloadYardId
      status
      lotNumber
      poNumber
      inboundShipmentId
      railCarNumber
      inboundShipmentId
      receivedAt
      turnDays
      quantityAdvised
      quantityReceived
      quantityOnHand
      quantityPhysical
      quantityCommitted
      quantityMismatch
      inventoryUOM
      verificationRequired
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      containerNumber
      lotType
      turnDays
      areaId
      area {
        areaType
        name
      }
      zoneId
      zone {
        name
        color
      }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      productName
      productId
      productCode
      pcs
      product {
        id
        pcs
      }
      accountId
      accountName
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        verified
        units
        sortKey
        commodity {
          id
          active
          sortKey
          name
          description
          defaultUnits
          locationLoadType
        }
      }
      inventoryItems {
        items {
          id
          quantityOnHand
          quantityCommitted
          hasException
          isDamaged
          otherException
          otherExceptionNote
          status
          unloadedBy
          unloadedAt
          inventoryId
          inboundShipmentId
          barcode
          originOfDamage
          reloadYardId
          areaId
          zoneId
          aisleId
          locationId
          location {
            id
            owner
            groups
            active
            reloadYardId
            name
            type
            productId
            productName
            areaId
            area {
              id
              owner
              groups
              active
              reloadYardId
              name
              prefix
              color
              areaType
              sortKey
            }
            zoneId
            zone {
              id
              owner
              groups
              active
              reloadYardId
              name
              prefix
              accountId
              areaId
              color
              zoneType
              sortKey
            }
            aisleId
            aisle {
              id
              owner
              groups
              active
              reloadYardId
              name
              type
              areaId
              zoneId
              bays
              levels
              capacityUsed
              topDownPickOrder
              sortKey
            }
            bay
            level
            position
            capacityUsed
            capacityAllocated
            bulkCapacity
            bulkUnits
            sortKey
            locationLoad {
              other {
                selected
                capacity
              }
              pallet {
                selected
                capacity
              }
              box {
                selected
                capacity
              }
              container {
                selected
                capacity
              }
              superSack {
                selected
                capacity
              }
              dryBulk {
                selected
                capacity
              }
              liquidBulk {
                selected
                capacity
              }
            }
          }
          history {
            type
            date
            by
            text
          }
          barcodes {
            items {
              id
              value
              status
              scannedIn
              scannedOut
              active
              inventoryItemId
            }
          }
          outboundShipmentId
          locationFullName
          latitude
          longitude
        }
      }
      customFields
    }
  }
`;

export const getInventorieAggregate = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
      groups
      reloadYardId
      status
      areaId
      zoneId
      lotNumber
      poNumber
      inboundShipmentId
      railCarNumber
      inboundShipmentId
      receivedAt
      depletedAt
      lastOutboundId
      turnDays
      quantityAdvised
      quantityReceived
      quantityOnHand
      quantityPhysical
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      turnDays
      history {
        type
        date
        by
        text
      }
      productName
      productId
      productCode
      accountId
      accountName
      inventoryItems {
        items {
          id
          inventoryId
          quantityOnHand
          quantityCommitted
          hasException
          isDamaged
          otherException
          otherExceptionNote
          status
          unloadedBy
          unloadedAt
          areaId
          zoneId
          aisleId
          locationId
          # location {
          #   id
          #   owner
          #   groups
          #   active
          #   reloadYardId
          #   name
          #   type
          #   productId
          #   productName
          #   areaId
          #   area {
          #     id
          #     owner
          #     groups
          #     active
          #     reloadYardId
          #     name
          #     prefix
          #     color
          #     areaType
          #     sortKey
          #   }
          #   zoneId
          #   zone {
          #     id
          #     owner
          #     groups
          #     active
          #     reloadYardId
          #     name
          #     prefix
          #     accountId
          #     areaId
          #     color
          #     zoneType
          #     sortKey
          #   }
          #   aisleId
          #   aisle {
          #     id
          #     owner
          #     groups
          #     active
          #     reloadYardId
          #     name
          #     type
          #     areaId
          #     zoneId
          #     bays
          #     levels
          #     capacityUsed
          #     topDownPickOrder
          #     sortKey
          #   }
          #   bay
          #   level
          #   position
          #   capacityUsed
          #   capacityAllocated
          #   bulkCapacity
          #   bulkUnits
          #   sortKey
          # }
          history {
            type
            date
            by
            text
          }
          outboundShipmentId
          locationFullName
          latitude
          longitude
        }
      }
      customFields
    }
  }
`;

export const getInventoryItem = /* GraphQL */ `
  query GetInventoryItem($id: ID!) {
    getInventoryItem(id: $id) {
      id
      # owner
      groups
      quantityOnHand
      quantityCommitted
      hasException
      isDamaged
      originOfDamage
      otherException
      otherExceptionNote
      status
      unloadedBy
      unloadedAt
      depletedAt
      inboundShipmentId
      inventoryId
      inventory {
        id
        groups
        active
        status
        lotNumber
        poNumber
        areaId
        zoneId
        aisleList
        accountId
        account {
          inventoryPrimaryField
          inventoryCustomFields {
            id
            name
            type
            display
            required
          }
        }
        railCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        overShipmentNote
        underShipment
        underShipmentQuantity
        underShipmentNote
        isDamaged
        isRecalled
        recallNote
        otherException
        otherExceptionNote
        lotType
        productId
        productName
        productCode
        product {
          id
          # owner
          # groups
          active
          # accountId
          # reloadYardId
          name
          # productCode
          reloadYardCommodityId
          # category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          # width
          # length
          # height
          # lowInventoryThreshold
          # totalInventoryQuantity
          # lowInventoryAlert
          customFields
        }
        sortKey
        accountName
        accountId
        reloadYardId
        inboundShipmentId
        inventoryItems {
          items {
            id
            quantityOnHand
            quantityCommitted
            updatedAt
            status
          }
          nextToken
        }
        shipmentLineItems {
          items {
            id
            status
            inventoryId
            outboundShipmentId
            outboundShipment {
              departureDateTime
              status
            }
            inventoryItems {
              items {
                id
                groups
                reloadYardId
                outboundShipmentId
                shipmentLineItemId
                inventoryId
                inventoryItemId
                quantityToPick
                quantityReturned
                scannedOut
                loadedBy
                units
                status
                updatedAt
              }
            }
          }
        }
        # photos {
        #   bucket
        #   region
        #   key
        # }
        history {
          type
          date
          by
          text
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          commodity {
            id
            name
            description
            locationLoadType
          }
          owner
          groups
          active
          verified
          units
          sortKey
        }
        customFields
        updatedAt
      }
      accountId
      areaId
      zoneId
      aisleId
      locationId
      location {
        id
        # owner
        groups
        active
        reloadYardId
        productId
        name
        type
        areaId
        area {
          id
          groups
          active
          name
          prefix
          color
          areaType
          sortKey
        }
        zoneId
        zone {
          id
          groups
          active
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
        }
        aisleId
        aisle {
          id
          active
          name
          type
          areaId
          zoneId
          bays
          levels
          positions
          capacityUsed
          length
          width
          sortKey
          topDownPickOrder
        }
        bay
        level
        position
        capacityUsed
        capacityAllocated
        length
        width
        sortKey
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        # tags {
        #   nextToken
        # }
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
      reloadYardId
      updatedAt
      history {
        type
        date
        by
        text
      }
      barcodes {
        items {
          id
          value
          status
          scannedIn
          scannedOut
          active
          inventoryId
          locationId
          inventoryItemId
        }
      }
    }
  }
`;

export const getInventoryItemMobile = /* GraphQL */ `
  query GetInventoryItem($id: ID!) {
    getInventoryItem(id: $id) {
      id
      quantityOnHand
      quantityCommitted
      hasException
      isDamaged
      otherException
      otherExceptionNote
      status
      unloadedBy
      unloadedAt
      inventoryId
      inboundShipmentId
      barcode
      originOfDamage
      reloadYardId
      areaId
      zoneId
      aisleId
      locationId
      location {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        productId
        productName
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
        }
        aisleId
        aisle {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          capacityUsed
          topDownPickOrder
          sortKey
        }
        bay
        level
        position
        capacityUsed
        capacityAllocated
        bulkCapacity
        bulkUnits
        sortKey
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
        }
      }
      history {
        type
        date
        by
        text
      }
      barcodes {
        items {
          id
          value
          status
          scannedIn
          scannedOut
          active
          inventoryItemId
          locationId
          inventoryId
          reloadYardId
          isScanned
        }
      }
      outboundShipmentId
      locationFullName
      latitude
      longitude
    }
  }
`;

export const getInventoryItemValidate = /* GraphQL */ `
  query GetInventoryItem($id: ID!) {
    getInventoryItem(id: $id) {
      id
      inventory {
        id
        updatedAt
      }
      updatedAt
    }
  }
`;

export const listAuditInventoriesByAccount = /* GraphQL */ `
  query InventoryByStatusByAccountByProductByLot(
    $reloadYardId: ID
    $statusAccountNameProductNameLotNumber: ModelInventoryInventoryByStatusByAccountByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountNameProductNameLotNumber: $statusAccountNameProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        areaId
        zoneId
        customFields
      }
      nextToken
    }
  }
`;

export const searchInventorys = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        id
        status
        lotNumber
        poNumber
        railCarNumber
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityCommitted
        quantityPhysical
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        hasException
        overShipment
        overShipmentQuantity
        underShipment
        underShipmentQuantity
        isDamaged
        isRecalled
        otherException
        aisleList
        accountName
        accountId
        account {
          businessName
          displayName
          accountType
          inventoryPrimaryField
          inventoryCustomFields {
            id
            name
            type
            display
          }
        }
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        lotType
        inventoryItems {
          items {
            # barcode
            id
            status
            quantityOnHand
            quantityCommitted
            updatedAt
            hasException
            isDamaged
            originOfDamage
            otherException
            otherExceptionNote
            areaId
            zoneId
            aisleId
            locationId
            location {
              id
              name
              type
              area {
                name
                prefix
                areaType
              }
              zone {
                name
                prefix
                accountId
              }
              aisle {
                id
                active
                name
                type
                bays
                levels
                capacityUsed
                length
                width
                sortKey
              }
              bay
              level
              position
            }
            barcodes {
              items {
                id
                value
                active
              }
            }
            outboundShipmentId
            inboundShipmentId
            locationFullName
            latitude
            longitude
          }
        }
        areaId
        area {
          areaType
        }
        productName
        productCode
        productId
        product {
          category
          lowInventoryAlert
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          pcs
          pcsHeight
          pcsWidth
          pcsLength
          mbf
          lf
          sf
          msf
          ft
          m
        }
        inboundShipmentId
        inboundShipment {
          poNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          carrierName
          lotType
          railCarNumber
        }
        shipmentLineItems {
          items {
            outboundShipment {
              status
            }
            inventoryItems {
              items {
                inventoryItemId
              }
            }
          }
        }
        reloadYardId
        reloadYardCommodityId
        customFields
        zoneId
      }
      nextToken
      total
    }
  }
`;

export const searchInventorysInbound = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        lotNumber
        poNumber
        railCarNumber
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityCommitted
        quantityPhysical
        quantityMismatch
        inventoryUOM
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        lotType
        inventoryItems {
          items {
            id
            quantityOnHand
            quantityCommitted
            areaId
            zoneId
            aisleId
            locationId
            location {
              id
              name
              type
              area {
                name
                prefix
                areaType
              }
              zone {
                name
                prefix
                accountId
              }
              aisle {
                id
                name
                type
                bays
                levels
                capacityUsed
                length
                width
                sortKey
              }
              bay
              level
              position
            }
            outboundShipmentId
            locationFullName
            latitude
            longitude
          }
        }
        productName
        productCode
        productId
        accountName
        account {
          businessName
          displayName
          accountType
        }
        customFields
      }
      nextToken
      total
    }
  }
`;

export const searchInventoryItems = /* GraphQL */ `
  query SearchInventoryItems(
    $filter: SearchableInventoryItemFilterInput
    $sort: SearchableInventoryItemSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventoryItems(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        inventoryId
      }
    }
  }
`;

// managerApp/InventoryList
export const inventoryByStatusByAccountByProductByLot = /* GraphQL */ `
  query InventoryByStatusByAccountByProductByLot(
    $reloadYardId: ID
    $statusAccountNameProductNameLotNumber: ModelInventoryInventoryByStatusByAccountByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountNameProductNameLotNumber: $statusAccountNameProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        active
        status
        lotNumber
        poNumber
        railCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        pcsHeight
        pcsWidth
        pcsLength
        pcs
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        underShipment
        underShipmentQuantity
        isDamaged
        isRecalled
        otherException
        lotType
        areaId
        zoneId
        aisleList
        productName
        productCode
        productId
        product {
          id
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
        }
        accountName
        accountId
        account {
          # id
          status
          lotNumberPrefix
          businessName
          displayName
          accountType
        }
        reloadYardId
        inboundShipmentId
        inventoryItems {
          items {
            id
            quantityOnHand
            quantityCommitted
            isDamaged
            originOfDamage
            otherException
            locationFullName
          }
        }
        auditId
        reloadYardCommodityId
        customFields
      }
      nextToken
    }
  }
`;

// customerApp/InventoryList
export const inventoryByStatusByAccountIdByProductByLot = /* GraphQL */ `
  query InventoryByStatusByAccountIdByProductByLot(
    $reloadYardId: ID
    $statusAccountIdProductNameLotNumber: ModelInventoryInventoryByStatusByAccountIdByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountIdByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountIdProductNameLotNumber: $statusAccountIdProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        active
        status
        lotNumber
        poNumber
        railCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        pcsHeight
        pcsWidth
        pcsLength
        pcs
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        hasException
        overShipment
        overShipmentQuantity
        underShipment
        underShipmentQuantity
        isDamaged
        isRecalled
        otherException
        lotType
        areaId
        zoneId
        aisleList
        productName
        productCode
        productId
        product {
          id
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          pcsHeight
          pcsWidth
          pcsLength
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
        }
        accountName
        accountId
        account {
          # id
          status
          lotNumberPrefix
          businessName
          displayName
          accountType
        }
        reloadYardId
        inboundShipmentId
        inventoryItems {
          items {
            id
            quantityOnHand
            quantityCommitted
            isDamaged
            originOfDamage
            otherException
            locationFullName
          }
        }
        auditId
        reloadYardCommodityId
        customFields
      }
      nextToken
    }
  }
`;

// outbound/InventorySearchDialog
export const outboundInventoryByStatusByAccountIdByProductByLot = /* GraphQL */ `
  query InventoryByStatusByAccountIdByProductByLot(
    $reloadYardId: ID
    $statusAccountIdProductNameLotNumber: ModelInventoryInventoryByStatusByAccountIdByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountIdByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountIdProductNameLotNumber: $statusAccountIdProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        active
        status
        lotNumber
        lotType
        poNumber
        containerNumber
        railCarNumber
        receivedAt
        depletedAt
        lastOutboundId
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        pcs
        pcsHeight
        pcsWidth
        pcsLength
        inventoryUOM
        weight
        weightUOM
        hasException
        overShipment
        overShipmentQuantity
        underShipment
        underShipmentQuantity
        isDamaged
        isRecalled
        otherException
        areaId
        zoneId
        productName
        productCode
        productId
        accountName
        accountId
        reloadYardId
        inboundShipmentId
        inboundShipment {
          sit
          status
          carrierType
          collectedDateTime
          isCollected
          railCarNumber
        }
        reloadYardCommodityId
        customFields
        sortKey
        history {
          type
          date
          by
          text
        }
        inventoryItems {
          items {
            id
            quantityOnHand
            quantityCommitted
            hasException
            isDamaged
            originOfDamage
            otherException
            otherExceptionNote
            status
            depletedAt
            # accountId  fix missing inventoryItem.account id on INTERNAL transfer - not needed
            areaId
            zoneId
            aisleId
            locationId
            outboundShipmentId
            locationFullName
            longitude
            latitude
            location {
              locationLoad {
                other {
                  selected
                  capacity
                }
                pallet {
                  selected
                  capacity
                }
                box {
                  selected
                  capacity
                }
                container {
                  selected
                  capacity
                }
                superSack {
                  selected
                  capacity
                }
                dryBulk {
                  selected
                  capacity
                }
                liquidBulk {
                  selected
                  capacity
                }
              }
              type
              area {
                sortKey
              }
              zone {
                sortKey
              }
              aisle {
                topDownPickOrder
                sortKey
              }
              bay
              level
              position
            }
            history {
              type
              date
              by
              text
            }
            updatedAt
          }
        }
        product {
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          sf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          pcsHeight
          pcsWidth
          pcsLength
        }
        # GET shipmentLineItems FOR NEGATIVE QTY DEBUGGING
        shipmentLineItems {
          items {
            id
            status
            totalQuantityToPick
            outboundShipmentId
            inventoryItems {
              items {
                id
                shipmentLineItemId
                inventoryItemId
                quantityToPick
                status
              }
            }
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;

export const inventoryByStatusByAccount = /* GraphQL */ `
  query InventoryByStatusByAccountByProductByLot(
    $reloadYardId: ID
    $statusAccountNameProductNameLotNumber: ModelInventoryInventoryByStatusByAccountByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountNameProductNameLotNumber: $statusAccountNameProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        railCarNumber
        receivedAt
        depletedAt
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        lotType
        areaId
        zoneId
        # latitude
        # longitude
        productName
        productCode
        productId
        sortKey
        accountName
        accountId
        inboundShipmentId
        auditId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const inventoryItemByLocationByStatusMini = /* GraphQL */ `
  query InventoryItemByLocationByStatus(
    $locationId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByLocationByStatus(
      locationId: $locationId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const inventoryItemByAisleByStatusMini = /* GraphQL */ `
  query InventoryItemByAisleByStatus(
    $aisleId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAisleByStatus(
      aisleId: $aisleId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const inventoryItemByZoneByStatusMini = /* GraphQL */ `
  query InventoryItemByZoneByStatus(
    $zoneId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByZoneByStatus(
      zoneId: $zoneId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const inventoryItemByAreaByStatusMini = /* GraphQL */ `
  query InventoryItemByAreaByStatus(
    $areaId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAreaByStatus(
      areaId: $areaId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const getInventorieTimeline = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
      status
      lotNumber
      poNumber
      railCarNumber
      receivedAt
      depletedAt
      quantityReceived
      quantityOnHand
      quantityPhysical
      quantityCommitted
      inventoryUOM
      weight
      weightUOM
      hasException
      overShipment
      overShipmentQuantity
      overShipmentNote
      underShipment
      underShipmentQuantity
      underShipmentNote
      isDamaged
      isRecalled
      recallNote
      otherException
      otherExceptionNote
      lotType
      areaId
      area {
        areaType
        name
      }
      outboundShipmentId
      # photos {
      #   bucket
      #   region
      #   key
      #   type
      # }
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      productName
      productCode
      productId
      accountName
      accountId
      account {
        businessName
        inboundCustomFields {
          id
          name
          type
          display
        }
        outboundCustomFields {
          id
          name
          type
          display
        }
        inventoryCustomFields {
          id
          name
          type
          display
        }
        inventoryPrimaryField
      }
      inboundShipmentId
      inboundShipment {
        id
        status
        state
        poNumber
        lotNumber
        carrierType
        carrierName
        lotType
        railCarNumber
        totalUOM
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        stripeBillingDateTime
        daysOnDemurrageClock
        # photos {
        #   items {
        #     bucket
        #     region
        #     key
        #     type
        #     createdBy
        #     createdAt
        #   }
        # }
        assignedTo
        unloadedBy
        reviewedBy
        secondaryReview
        verificationRequired
        hasException
        unsafeShipment
        unsafeShipmentNote
        brokenSeal
        brokenSealNote
        otherException
        otherExceptionNote
        instructions
        checklist {
          id
          name
          description
          stepName
          isRequired
          isCompleted
          completedBy
          completedAt
        }
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
        }
        invoice {
          id
        }
        area {
          name
          prefix
          color
          areaType
        }
        zone {
          name
          prefix
        }
        isCollected
        customFields
        selectedCustomFields {
          id
          name
          type
          display
        }
      }
      shipmentLineItems {
        items {
          id
          status
          sortKey
          lotNumber
          poNumber
          totalQuantityToPick
          notes {
            type
            date
            by
            text
            public
          }
          history {
            type
            date
            by
            text
          }
          outboundShipmentId
          outboundShipment {
            id
            poNumber
            pickupNumber
            carrierType
            carrierName
            bolNumber
            railCarNumber
            scheduledDateTime
            arrivalDateTime
            placementDateTime
            startDateTime
            endDateTime
            departureDateTime
            collectedDateTime
            deliveryDateTime
            daysOnDemurrageClock
            ladenWeight
            totalUOM
            accountName
            invoiceId
            customFields
          }
          inventoryItems {
            items {
              id
              inventoryId
              quantityToPick
              status
              inventoryItem {
                id
                quantityOnHand
                quantityCommitted
                status
                locationFullName
              }
            }
          }
        }
      }
      reloadYardCommodity {
        commodityId
        units
        commodity {
          name
          description
          defaultUnits
          locationLoadType
        }
      }
      inventoryItems {
        items {
          id
          quantityOnHand
          quantityCommitted
          hasException
          isDamaged
          originOfDamage
          otherException
          otherExceptionNote
          status
          history {
            type
            date
            by
            text
          }
          barcode
          locationFullName
          unloadedBy
          unloadedAt
        }
      }
      customFields
    }
  }
`;

export const countInventories = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      total
    }
  }
`;
